'use strict';

module.exports = {
	PROGRESSION_INTRO: 'This badge shows you can do the following things:',
	UNLOCK_INFO: {
		FIRST_AWARDED: 'First collected',
		LAST_AWARDED: 'Recently collected',
		COUNT: 'Total Collected'
	},
	HEADINGS: {
		COMMON: 'Core',
		UNCOMMON: 'Advanced',
		RARE: 'Expert',
		EPIC: 'Epic'
	}
};
